import React from 'react';

const modules = [
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/>
      </svg>
    ),
    title: 'Platform Owner Portal',
    desc: 'Super-admin control panel to manage organizations, subscriptions, billing, and system-wide configurations.',
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>
      </svg>
    ),
    title: 'Organization Portal',
    desc: 'Admins manage departments, create rosters, approve leaves, and monitor workforce performance from a single dashboard.',
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
      </svg>
    ),
    title: 'Staff Portal',
    desc: 'Employees view their schedules, clock in/out, request leave, check payslips, and receive real-time notifications.',
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="5" y="2" width="14" height="20" rx="2" ry="2"/><line x1="12" y1="18" x2="12.01" y2="18"/>
      </svg>
    ),
    title: 'Mobile Ready',
    desc: 'Fully responsive design works on any device. Staff can manage everything from their phone — no app downloads needed.',
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/>
      </svg>
    ),
    title: 'In-App Notifications',
    desc: 'Real-time alerts for shift changes, leave approvals, roster publications, and important updates. Never miss a beat.',
  },
  {
    icon: (
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/>
      </svg>
    ),
    title: 'Billing & Invoicing',
    desc: 'Automated invoicing, subscription management, and payment tracking. Generate professional invoices with one click.',
  },
];

function Modules() {
  return (
    <section className="section" id="modules">
      <div className="container">
        <div className="section-header">
          <div className="section-badge">Platform</div>
          <h2 className="section-title">Three Portals, One Unified Platform</h2>
          <p className="section-subtitle">
            Purpose-built interfaces for every stakeholder — from platform owners
            to organization admins to individual staff members.
          </p>
        </div>
        <div className="modules-grid">
          {modules.map((m, i) => (
            <div className={`module-card fade-in fade-in-delay-${(i % 3) + 1}`} key={i}>
              <div className="module-icon">{m.icon}</div>
              <div>
                <h3 className="module-title">{m.title}</h3>
                <p className="module-desc">{m.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Modules;
